import React, { useEffect, useState } from "react";
import AuthHeaderPage from "../features/auth/authHeader.js";
import Header from "../common/header/header.js";
import Footer from "../common/footer/footer.js";
import DashboardFilters from "../features/dashboard/dashboard-filters/dashboard-filters.js";
import { useParams, useLocation } from "react-router-dom";
import "./layout.css";

const Layout = ({ children }) => {
  const params = useParams();
  const location = useLocation();
  const currentSelectedDropdownValue = location.pathname;

  let isPublicRoute = false;
  if (
    window.location.pathname.toLocaleLowerCase() === "/hpcl" ||
    window.location.pathname.toLocaleLowerCase() === "/hpcl/" ||
    window.location.pathname.toLocaleLowerCase() === "/hpcl/login" ||
    window.location.pathname === "/hpcl/registration" ||
    window.location.pathname === "/hpcl/forgot-password"
  )
    isPublicRoute = true;
  return (
    <div>
      {isPublicRoute ? (
        <AuthHeaderPage />
      ) : (
        <>
          <Header />
          <div className="dashbord-page-filters mt-1">
            <DashboardFilters
              currentSelectedValue={currentSelectedDropdownValue}
            />
          </div>
        </>
      )}
      <div
        className={
          !isPublicRoute
            ? "container-fluid body-content p-0"
            : "container-fluid login-body-content p-0"
        }
      >
        {children}
      </div>
      {/* {isPublicRoute ? null : <Footer />} */}
    </div>
  );
};

export default Layout;
